var map = {
	"./01.gif": "0c39",
	"./02.gif": "a314",
	"./03.gif": "f8de",
	"./04.gif": "802c",
	"./05.gif": "7a1f",
	"./06.gif": "01fc",
	"./07.gif": "eb1d",
	"./08.gif": "3fdf",
	"./09.gif": "e5d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d2f";